// Multi-Client Theme Provider for ROIS Frontend
// Soporte para múltiples clientes (Cora, ROIS, etc.)

import React, { useState, useEffect, ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeMode, ThemeBrand, ThemeConfig } from './types';
import { getTheme } from './themes';

// Configuración por defecto
const DEFAULT_CONFIG: ThemeConfig = {
  brand: 'cora', // Por defecto CORA
  mode: 'light',
};

interface ThemeProviderProps {
  children: ReactNode;
  initialBrand?: ThemeBrand;
  initialMode?: ThemeMode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  initialBrand = 'cora',
  initialMode = 'light',
}) => {
  const [config, setConfig] = useState<ThemeConfig>({
    brand: initialBrand,
    mode: initialMode,
  });

  // Cargar configuración desde localStorage
  useEffect(() => {
    const savedConfig = localStorage.getItem(
      `${config.brand}-theme-mode`
    ) as ThemeMode;
    if (savedConfig === 'light' || savedConfig === 'dark') {
      setConfig((prev) => ({ ...prev, mode: savedConfig }));
    }
  }, [config.brand]);

  // Guardar configuración en localStorage
  useEffect(() => {
    localStorage.setItem(`${config.brand}-theme-mode`, config.mode);
  }, [config.brand, config.mode]);

  const currentTheme = getTheme(config.brand, config.mode);

  return (
    <StyledThemeProvider theme={currentTheme}>{children}</StyledThemeProvider>
  );
};

export default ThemeProvider;
